import * as THREE from 'three';

export default class BakedModel {
    model: LoadedModel;
    texture: LoadedTexture;
    material: THREE.MeshBasicMaterial;

    constructor(model: LoadedModel, texture: LoadedTexture, scale?: number) {
        this.model = model;
        this.texture = texture;

        this.texture.flipY = false;
        this.texture.encoding = THREE.sRGBEncoding;

        this.material = new THREE.MeshBasicMaterial({
            map: this.texture,
        });

        this.model.scene.traverse((child) => {
            if (
                child.name.toLowerCase().includes('logo') ||
                child.name.toLowerCase().includes('brand') ||
                child.name.toLowerCase().includes('text') ||
                child.name.toLowerCase().includes('Naveen') ||
                child.name.toLowerCase().includes('M') ||
                child.name.toLowerCase().includes('name') ||
                child.name.toLowerCase().includes('heffernan') ||
                child.name.toLowerCase().includes('monitor_brand') ||
                child.name.toLowerCase().includes('henry')
            ) {
                child.visible = false;
            }
            if (child instanceof THREE.Mesh) {
                if (scale) child.scale.set(scale, scale, scale);
                child.material.map = this.texture;
                child.material = this.material;
            }
        });

        return this;
    }

    getModel(): THREE.Group {
        return this.model.scene;
    }
}
